import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {marked} from "marked";
import {httpResource} from "@angular/common/http";

@Component({
  selector: 'homey-wiki-page',
  templateUrl: './wiki-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WikiPageComponent {
  public readonly slug = input.required<string>();

  private readonly markdownResource = httpResource.text(() => `/assets/wiki/${this.slug()}.md`);

  public readonly markdown = computed(() => {
    const raw = this.markdownResource.value();
    return raw ? marked.parse(raw, {async: false}) : '';
  });
}
